import styled from 'styled-components';

const Title = styled.h1`
    font-size: 1.65em;
    text-transform:uppercase;
`;

export default Title;
